import React from 'react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { MOTORWAY_PAY_FAQ_LINK } from 'Components/StaticPages/MotorwayPayModulr/MotorwayPayModulr.helper';

import { SNOWPLOW_EVENTS } from '../../../../services/analytics/analytics.const';
import { motorwayPayPageEvents } from '../../../../services/analytics/events/paymentEvents/motorwayPayPageEvents';

import { FAQFirstSection } from './FAQFirstSection';
import { FAQSecondSection } from './FAQSecondSection';
import { FAQTestimonialVideo } from './FAQTestimonialVideo';
import { FAQThirdSection } from './FAQThirdSection';

import styles from './FAQSection.module.scss';

export type FAQSectionProps = {
	isLoggedOut: boolean;
};

export const FAQSection: React.FC<FAQSectionProps> = ({ isLoggedOut }) => {
	return (
		<>
			<section className={styles.faq}>
				<div className={styles.video}>
					<FAQTestimonialVideo />
				</div>
				<div className={styles.faqSection}>
					<h1 className={styles.title}>FAQs</h1>
					<FAQFirstSection isLoggedOut={isLoggedOut} />
					<FAQThirdSection />
					<FAQSecondSection isLoggedOut={isLoggedOut} />
					{!isLoggedOut && (
						<p className={styles.moreQuestions}>
							If you have any more questions, check out our{' '}
							<Hyperlink
								as="a"
								href={MOTORWAY_PAY_FAQ_LINK}
								label="Help Centre"
								onClick={() => {
									motorwayPayPageEvents<{
										label: string;
									}>({
										customData: {
											label: 'help_centre_link',
										},
										name: 'Link clicked',
										schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
										version: SNOWPLOW_EVENTS.CLICK.VERSION,
									});
								}}
								target="_blank"
							/>
							.
						</p>
					)}
				</div>
			</section>
		</>
	);
};
